<template>
  <router-view />
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  // created() {
  //   let uri = window.location.search.substring(1);
  //   if (uri && this.$router.currentRoute.path === '/') {
  //     this.$store.dispatch("auth/getData");
  //   }
  // },
  async mounted() {
    var clientId = localStorage.getItem("clientId");
    var sessionId = localStorage.getItem("sessionId");
    if (!!clientId && !!sessionId) {
      this.$store.commit("setUserId", clientId);
      this.$store.commit("setSessionId", sessionId);
    }
  },
};
</script>
